// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__3S_oL","subheader":"ReorderModal_subheader__2TpSs","listWrap":"ReorderModal_listWrap__ZTrYq"};